<script setup>
import { computed } from 'vue';

const props = defineProps({
  url: { type: String },
  text: { type: String, default: '' },
  linkText: { type: String },
  target: { type: String, default: '_self' },
  title: { type: String, default: '' },
});

const emit = defineEmits(['click']);

const parsedText = computed(() => {
  if (!props.linkText || !props.text.includes(props.linkText)) {
    return [props.text];
  }
  return props.text
    .split(props.linkText)
    .flatMap((part, index, array) =>
      index < array.length - 1 ? [part, props.linkText] : [part],
    );
});

function handleClick(event) {
  event.stopImmediatePropagation();
  emit('click');
}
</script>

<template>
  <span>
    <template v-for="(part, index) in parsedText" :key="index">
      <a
        v-if="!linkText || part === linkText"
        :href="url"
        :class="[$attrs.class, $style.link]"
        :target="target"
        :title="title"
        @click="handleClick"
      >
        {{ part }}
      </a>
      <span v-else>{{ part }}</span>
    </template>
  </span>
</template>

<style lang="less" module>
.link {
  text-decoration: underline;
  color: @color-black;
  cursor: pointer;
}
</style>
